<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="form_laive validateClient">
        <div class="box_loader">
          <div class="loader"></div>
        </div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1 pt-0 mt-0"
        >
          <template v-slot:header>
            <h3 class="mb-0">Creación de Promocion</h3>
          </template>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <ul class="progressbar_vertical">
                  <li class="step_grupo" data-text="Grupo objetivo">1</li>
                  <li class="step_grupo" data-text="Promociones">2</li>
                </ul>
              </div>
              <div class="col-md-10">
                  <div class="promotion_header">
                    <h3>Elige la forma de definir tu muestra de estudio</h3>
                    <div class="box_access">
                      <div class="box_access__item" ref="create_group" @click="clickCreateGroup">
                        <div class="icon">
                          <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.91699 2.08331C4.91699 1.61918 5.10137 1.17406 5.42956 0.845876C5.75774 0.517688 6.20286 0.333313 6.66699 0.333313H11.3337C11.7978 0.333313 12.2429 0.517688 12.5711 0.845876C12.8993 1.17406 13.0837 1.61918 13.0837 2.08331V3.24998C13.0837 3.71411 12.8993 4.15923 12.5711 4.48742C12.2429 4.81561 11.7978 4.99998 11.3337 4.99998H6.66699C6.20286 4.99998 5.75774 4.81561 5.42956 4.48742C5.10137 4.15923 4.91699 3.71411 4.91699 3.24998V2.08331ZM6.66699 1.49998C6.51228 1.49998 6.36391 1.56144 6.25451 1.67083C6.14512 1.78023 6.08366 1.9286 6.08366 2.08331V3.24998C6.08366 3.40469 6.14512 3.55306 6.25451 3.66246C6.36391 3.77185 6.51228 3.83331 6.66699 3.83331H11.3337C11.4884 3.83331 11.6367 3.77185 11.7461 3.66246C11.8555 3.55306 11.917 3.40469 11.917 3.24998V2.08331C11.917 1.9286 11.8555 1.78023 11.7461 1.67083C11.6367 1.56144 11.4884 1.49998 11.3337 1.49998H6.66699Z" fill="#02A54F"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.50016 2.08331H2.5835C2.11937 2.08331 1.67425 2.26769 1.34606 2.59588C1.01787 2.92406 0.833496 3.36918 0.833496 3.83331V21.9166C0.833496 22.3808 1.01787 22.8259 1.34606 23.1541C1.67425 23.4823 2.11937 23.6666 2.5835 23.6666H15.4168C15.881 23.6666 16.3261 23.4823 16.6543 23.1541C16.9825 22.8259 17.1668 22.3808 17.1668 21.9166V3.83331C17.1668 3.36918 16.9825 2.92406 16.6543 2.59588C16.3261 2.26769 15.881 2.08331 15.4168 2.08331H12.5002V3.24998C12.5002 3.5594 12.3772 3.85615 12.1585 4.07494C11.9397 4.29373 11.6429 4.41665 11.3335 4.41665H6.66683C6.35741 4.41665 6.06067 4.29373 5.84187 4.07494C5.62308 3.85615 5.50016 3.5594 5.50016 3.24998V2.08331ZM3.75016 10.25C3.75016 10.0953 3.81162 9.9469 3.92102 9.8375C4.03041 9.7281 4.17879 9.66665 4.3335 9.66665H8.41683C8.57154 9.66665 8.71991 9.7281 8.82931 9.8375C8.93871 9.9469 9.00016 10.0953 9.00016 10.25C9.00016 10.4047 8.93871 10.5531 8.82931 10.6625C8.71991 10.7719 8.57154 10.8333 8.41683 10.8333H4.3335C4.17879 10.8333 4.03041 10.7719 3.92102 10.6625C3.81162 10.5531 3.75016 10.4047 3.75016 10.25ZM4.3335 6.74998C4.17879 6.74998 4.03041 6.81144 3.92102 6.92083C3.81162 7.03023 3.75016 7.1786 3.75016 7.33331C3.75016 7.48802 3.81162 7.6364 3.92102 7.74579C4.03041 7.85519 4.17879 7.91665 4.3335 7.91665H13.3752C13.5299 7.91665 13.6782 7.85519 13.7876 7.74579C13.897 7.6364 13.9585 7.48802 13.9585 7.33331C13.9585 7.1786 13.897 7.03023 13.7876 6.92083C13.6782 6.81144 13.5299 6.74998 13.3752 6.74998H4.3335ZM4.91683 14.9166V16.0833H6.0835V14.9166H4.91683ZM4.3335 13.75C4.17879 13.75 4.03041 13.8114 3.92102 13.9208C3.81162 14.0302 3.75016 14.1786 3.75016 14.3333V16.6666C3.75016 16.8214 3.81162 16.9697 3.92102 17.0791C4.03041 17.1885 4.17879 17.25 4.3335 17.25H6.66683C6.82154 17.25 6.96991 17.1885 7.07931 17.0791C7.18871 16.9697 7.25016 16.8214 7.25016 16.6666V14.3333C7.25016 14.1786 7.18871 14.0302 7.07931 13.9208C6.96991 13.8114 6.82154 13.75 6.66683 13.75H4.3335ZM13.0835 14.9166C13.0835 15.3808 12.8991 15.8259 12.5709 16.1541C12.2427 16.4823 11.7976 16.6666 11.3335 16.6666C10.8694 16.6666 10.4242 16.4823 10.0961 16.1541C9.76787 15.8259 9.5835 15.3808 9.5835 14.9166C9.5835 14.4525 9.76787 14.0074 10.0961 13.6792C10.4242 13.351 10.8694 13.1666 11.3335 13.1666C11.7976 13.1666 12.2427 13.351 12.5709 13.6792C12.8991 14.0074 13.0835 14.4525 13.0835 14.9166ZM11.3335 17.4355C10.1651 17.4355 7.8335 18.0573 7.8335 19.2916V20.75H14.8335V19.2916C14.8335 18.0573 12.5019 17.4355 11.3335 17.4355Z" fill="#02A54F"/>
                            </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Definir grupo objetivo</h4>
                          <p class="text">Selecciona las características de tu muestra.</p>
                        </div>
                      </div>

                      <div class="box_access__item" ref="upload_file" @click="clickUploadFile">
                        <div class="icon">
                          <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.0277 6.02752L11.7952 0.79502C11.3943 0.394187 10.8418 0.166687 10.2677 0.166687H2.50016C1.3085 0.166687 0.34433 1.14169 0.34433 2.33335L0.333496 19.6667C0.333496 20.8584 1.29766 21.8334 2.48933 21.8334H15.5002C16.6918 21.8334 17.6668 20.8584 17.6668 19.6667V7.56585C17.6668 6.99169 17.4393 6.43919 17.0277 6.02752ZM12.0335 14.25H10.0835V17.5C10.0835 18.0959 9.596 18.5834 9.00016 18.5834C8.40433 18.5834 7.91683 18.0959 7.91683 17.5V14.25H5.97766C5.49016 14.25 5.25183 13.665 5.5985 13.3292L8.63183 10.3067C8.8485 10.1009 9.18433 10.1009 9.401 10.3067L12.4235 13.3292C12.7485 13.665 12.5102 14.25 12.0335 14.25ZM11.1668 7.75002C10.571 7.75002 10.0835 7.26252 10.0835 6.66669V1.79169L16.0418 7.75002H11.1668Z" fill="#6E6E6E"/>
                          </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Carga Masiva</h4>
                          <p class="text">Sube las promociones mediante un archivo.</p>
                        </div>
                      </div>

                      <div class="box_access__item" ref="create_promo" @click="clickCreatePromo">
                        <div class="icon">
                          <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.91699 2.08331C4.91699 1.61918 5.10137 1.17406 5.42956 0.845876C5.75774 0.517688 6.20286 0.333313 6.66699 0.333313H11.3337C11.7978 0.333313 12.2429 0.517688 12.5711 0.845876C12.8993 1.17406 13.0837 1.61918 13.0837 2.08331V3.24998C13.0837 3.71411 12.8993 4.15923 12.5711 4.48742C12.2429 4.81561 11.7978 4.99998 11.3337 4.99998H6.66699C6.20286 4.99998 5.75774 4.81561 5.42956 4.48742C5.10137 4.15923 4.91699 3.71411 4.91699 3.24998V2.08331ZM6.66699 1.49998C6.51228 1.49998 6.36391 1.56144 6.25451 1.67083C6.14512 1.78023 6.08366 1.9286 6.08366 2.08331V3.24998C6.08366 3.40469 6.14512 3.55306 6.25451 3.66246C6.36391 3.77185 6.51228 3.83331 6.66699 3.83331H11.3337C11.4884 3.83331 11.6367 3.77185 11.7461 3.66246C11.8555 3.55306 11.917 3.40469 11.917 3.24998V2.08331C11.917 1.9286 11.8555 1.78023 11.7461 1.67083C11.6367 1.56144 11.4884 1.49998 11.3337 1.49998H6.66699Z" fill="#02A54F"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.50016 2.08331H2.5835C2.11937 2.08331 1.67425 2.26769 1.34606 2.59588C1.01787 2.92406 0.833496 3.36918 0.833496 3.83331V21.9166C0.833496 22.3808 1.01787 22.8259 1.34606 23.1541C1.67425 23.4823 2.11937 23.6666 2.5835 23.6666H15.4168C15.881 23.6666 16.3261 23.4823 16.6543 23.1541C16.9825 22.8259 17.1668 22.3808 17.1668 21.9166V3.83331C17.1668 3.36918 16.9825 2.92406 16.6543 2.59588C16.3261 2.26769 15.881 2.08331 15.4168 2.08331H12.5002V3.24998C12.5002 3.5594 12.3772 3.85615 12.1585 4.07494C11.9397 4.29373 11.6429 4.41665 11.3335 4.41665H6.66683C6.35741 4.41665 6.06067 4.29373 5.84187 4.07494C5.62308 3.85615 5.50016 3.5594 5.50016 3.24998V2.08331ZM3.75016 10.25C3.75016 10.0953 3.81162 9.9469 3.92102 9.8375C4.03041 9.7281 4.17879 9.66665 4.3335 9.66665H8.41683C8.57154 9.66665 8.71991 9.7281 8.82931 9.8375C8.93871 9.9469 9.00016 10.0953 9.00016 10.25C9.00016 10.4047 8.93871 10.5531 8.82931 10.6625C8.71991 10.7719 8.57154 10.8333 8.41683 10.8333H4.3335C4.17879 10.8333 4.03041 10.7719 3.92102 10.6625C3.81162 10.5531 3.75016 10.4047 3.75016 10.25ZM4.3335 6.74998C4.17879 6.74998 4.03041 6.81144 3.92102 6.92083C3.81162 7.03023 3.75016 7.1786 3.75016 7.33331C3.75016 7.48802 3.81162 7.6364 3.92102 7.74579C4.03041 7.85519 4.17879 7.91665 4.3335 7.91665H13.3752C13.5299 7.91665 13.6782 7.85519 13.7876 7.74579C13.897 7.6364 13.9585 7.48802 13.9585 7.33331C13.9585 7.1786 13.897 7.03023 13.7876 6.92083C13.6782 6.81144 13.5299 6.74998 13.3752 6.74998H4.3335ZM4.91683 14.9166V16.0833H6.0835V14.9166H4.91683ZM4.3335 13.75C4.17879 13.75 4.03041 13.8114 3.92102 13.9208C3.81162 14.0302 3.75016 14.1786 3.75016 14.3333V16.6666C3.75016 16.8214 3.81162 16.9697 3.92102 17.0791C4.03041 17.1885 4.17879 17.25 4.3335 17.25H6.66683C6.82154 17.25 6.96991 17.1885 7.07931 17.0791C7.18871 16.9697 7.25016 16.8214 7.25016 16.6666V14.3333C7.25016 14.1786 7.18871 14.0302 7.07931 13.9208C6.96991 13.8114 6.82154 13.75 6.66683 13.75H4.3335ZM13.0835 14.9166C13.0835 15.3808 12.8991 15.8259 12.5709 16.1541C12.2427 16.4823 11.7976 16.6666 11.3335 16.6666C10.8694 16.6666 10.4242 16.4823 10.0961 16.1541C9.76787 15.8259 9.5835 15.3808 9.5835 14.9166C9.5835 14.4525 9.76787 14.0074 10.0961 13.6792C10.4242 13.351 10.8694 13.1666 11.3335 13.1666C11.7976 13.1666 12.2427 13.351 12.5709 13.6792C12.8991 14.0074 13.0835 14.4525 13.0835 14.9166ZM11.3335 17.4355C10.1651 17.4355 7.8335 18.0573 7.8335 19.2916V20.75H14.8335V19.2916C14.8335 18.0573 12.5019 17.4355 11.3335 17.4355Z" fill="#02A54F"/>
                            </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Copia de Grupo Objetivo</h4>
                          <p class="text">En base una grupo Objetivo existente.</p>
                        </div>
                      </div>
                    </div>
                    <base-button type="primary" disabled native-type="button" class="btn-default my-0 initCreatePromo" @click="nextStep">Aceptar</base-button>
                  </div>

                  <div class="box_step_grupo d-none">
                    <h3>Definición del Grupo objetivo</h3>
                    <form @submit.prevent="createGrupo">
                      <label class="col-form-label form-control-label">Distribuidoras:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allDis" class="custom-control-input" value="allDis" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allDis" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in distribuidoras" :key="item.idDistribuidora">
                          <input :id="item.idDistribuidora" class="custom-control-input item" :value="item.idDistribuidora" type="checkbox" v-model="selectDistribuidoras">
                          <label :for="item.idDistribuidora" class="custom-control-label"><strong> {{ item.razonSocial }}</strong></label>
                        </div>
                      </div>
                      <label class="col-form-label form-control-label">Tipo de Vendedor:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allVendedor" class="custom-control-input" value="allVendedor" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allVendedor" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in tiposVendedor" :key="item.codigo">
                          <input :id="item.codigo" class="custom-control-input item" :value="item.codigo" type="checkbox" v-model="selectVendedor">
                          <label :for="item.codigo" class="custom-control-label"><strong> {{ item.nombre.toLowerCase() }}</strong></label>
                        </div>
                      </div>
                      <label class="col-form-label form-control-label">Giros:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allGiros" class="custom-control-input" value="allGiros" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allGiros" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in giros" :key="item.codigo">
                          <input :id="item.nombre" class="custom-control-input item" :value="item.nombre" type="checkbox" v-model="selectGiros">
                          <label :for="item.nombre" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>
                      <label class="col-form-label form-control-label">Segmentos:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allSegment" class="custom-control-input" value="allSegment" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allSegment" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in segmentos" :key="item.codigo">
                          <input :id="item.nombre" class="custom-control-input item" :value="item.nombre" type="checkbox" v-model="selectSegmentos">
                          <label :for="item.nombre" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>
                      <label class="col-form-label form-control-label">Cluster:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allCluster" class="custom-control-input" value="allCluster" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allCluster" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in clusters" :key="item.codigo">
                          <input :id="item.nombre" class="custom-control-input item" :value="item.nombre" type="checkbox" v-model="selectCluster">
                          <label :for="item.nombre" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>

                      <label class="col-form-label form-control-label">Grupos de venta:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allGrupoVenta" class="custom-control-input" value="allGrupoVenta" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allGrupoVenta" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in grupoVenta" :key="item.codigo">
                          <input :id="`${item.nombre}-gp`" class="custom-control-input item" :value="item.nombre" type="checkbox" v-model="selectGrupoVenta">
                          <label :for="`${item.nombre}-gp`" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>

                      <label class="col-form-label form-control-label">Días de atención:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allDias" class="custom-control-input" value="allDias" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allDias" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in diasSemana" :key="item.codigo">
                          <input :id="item.codigo" class="custom-control-input item" :value="item.codigo" type="checkbox" v-model="selectDias">
                          <label :for="item.codigo" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Nombre del Grupo:</label>
                          <base-input
                            name="nombre_grupo"
                            required="required"
                            placeholder="Descripción"
                            :value="grupoObjetivo.nombre"
                            v-model="grupoObjetivo.nombre"
                          ></base-input>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Distrito:</label>
                            <el-select multiple
                                      v-model="grupoObjetivo.ubigeoTemp"
                                      placeholder="Selecconar"
                            >
                              <el-option v-for="item in distritos"
                                        :value="item.codigo"
                                        :label="item.nombre"
                                        :key="item.codigo">
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Venta Mínima:</label>
                            <base-input
                              required
                              name="venta_minima"
                              placeholder=""
                              v-model.number="grupoObjetivo.minVenta"
                              @keypress="isNumber($event)"
                            >
                              <template v-slot:addonLeft>S/</template>
                            </base-input>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Venta Máxima:</label>
                            <base-input
                              required
                              name="venta_maxima"
                              placeholder=""
                              v-model.number="grupoObjetivo.maxVenta"
                              @keypress="isNumber($event)"
                            >
                              <template v-slot:addonLeft>S/</template>
                            </base-input>
                          </div>
                        </div>
                      </div>
                      <base-button type="" @click="backStep" >&lt; Regresar</base-button>
                      <base-button type="primary" native-type="submit" class="btn-default my-0">Crear Grupo Objetivo</base-button>
                    </form>
                  </div>

                  <div class="box_step_promotion d-none">
                    <h3>Definición de la Promoción</h3>
                    <form @submit.prevent="submitCreate">
                      <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="col-form-label form-control-label">Grupo Objetivo:</label>
                              <Select2 v-model.number="dataSend.idGrupo" class="select2_laive" name="producto_objetivo" id="producto_objetivo" required :options="listGroup" placeholder="Seleccione un Grupo" @select="changeGroup($event)"/>
                            </div>
                          </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Producto:</label>
                            <Select2 v-model="dataSend.codigoProducto" class="select2_laive" name="product_principal" id="product_principal" required :options="listProducts" :settings="{matcher: matchProduct}" placeholder="Seleccione un Producto"/>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Producto Asociado:</label>
                            <Select2 v-model="dataSend.codigoProductoAsociado" class="select2_laive" name="product_asociado" id="product_asociado" required :options="listProductsAsociados" :settings="{matcher: matchProduct}" placeholder="Seleccione un Producto Asociado"/>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Código:</label>
                          <base-input
                            name="code_promo"
                            required="required"
                            placeholder="Código Promocion"
                            :value="dataSend.codigoPromocion"
                            v-model="dataSend.codigoPromocion"
                          ></base-input>
                        </div>
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Nombre:</label>
                          <base-input
                            name="name_promo"
                            required="required"
                            placeholder="Nombre Promocion"
                            :value="dataSend.nombre"
                            v-model="dataSend.nombre"
                          ></base-input>
                        </div>
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Descripción:</label>
                          <base-input
                            name="descripcion"
                            required="required"
                            placeholder="Descripción"
                            maxlength="50"
                            :value="dataSend.descripcion"
                            v-model="dataSend.descripcion"
                          ></base-input>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2">
                          <label class="col-form-label form-control-label">Cantidad Mínima:</label>
                          <base-input
                            name="cantidad_minima"
                            required="required"
                            placeholder="Cantidad Mínima"
                            :value="dataSend.cantidadMinima"
                            v-model.number="dataSend.cantidadMinima"
                            @keypress="isNumber($event)"
                          ></base-input>
                        </div>
                        <div class="col-md-2">
                          <label class="col-form-label form-control-label">Cantidad Máxima:</label>
                          <base-input
                            name="cantidad_máxima"
                            required="required"
                            placeholder="Cantidad Máxima"
                            :value="dataSend.cantidadMaxima"
                            v-model.number="dataSend.cantidadMaxima"
                            @keypress="isNumber($event)"
                          ></base-input>
                        </div>
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Condición</label>
                          <div class="form-group">
                            <select class="form-control" name="condicion_select" v-model.number="dataSend.obligatorio">
                              <option value="" selected disabled>Seleccionar</option>
                              <option value="0">Flexible</option>
                              <option value="1">Obligatoria</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Fecha de Inicio:</label>
                            <base-input addon-left-icon="ni ni-calendar-grid-58" name="fechaInicio">
                              <flat-picker :config="configDate" class="form-control datepicker" v-model="dataSend.fechaInicio"></flat-picker>
                            </base-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Fecha Fin:</label>
                            <base-input addon-left-icon="ni ni-calendar-grid-58" name="fechaFin">
                              <flat-picker :config="configDate" class="form-control datepicker" v-model="dataSend.fechaFin"></flat-picker>
                            </base-input>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Cant. productos por Promoción:</label>
                          <base-input
                            name="products_cant"
                            required="required"
                            placeholder="Productos por promoción"
                            :value="dataSend.cantidadPromocion"
                            v-model.number="dataSend.cantidadPromocion"
                            @keypress="isNumber($event)"
                          ></base-input>
                        </div>
                        <div class="col-md-2">
                          <label class="col-form-label form-control-label">Productos Disponibles:</label>
                          <base-input
                            name="products_dispo"
                            required="required"
                            placeholder="Cantidad Máxima"
                            :value="dataSend.maximoDisponible"
                            v-model.number="dataSend.maximoDisponible"
                            @keypress="isNumber($event)"
                          ></base-input>
                        </div>
                      </div>
                      <base-button type="" @click="backStep" >&lt; Regresar</base-button>
                      <base-button type="primary" native-type="submit" class="btn-default my-0">Crear Promoción</base-button>
                    </form>
                  </div>

                  <div class="box_step_upload d-none">
                    <h3>Cargar Excel</h3>
                    <div>
                      <dropzone-file-upload v-model="filePromo" :options="configDropZone" @addedfile="addFile" class="custom_file_import" ></dropzone-file-upload>
                      <base-button type="" @click="backStep" >&lt; Regresar</base-button>
                      <base-button type="primary" native-type="button" class="btn-default my-0" @click="uploadFilePromo">Cargar Promociones</base-button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import {mapActions,mapGetters} from 'vuex';
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";
import Select2 from 'vue3-select2-component';
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es.js';
import swal from "sweetalert2";
import { ElSelect, ElOption } from "element-plus";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    RouteBreadCrumb,
    Select2,
    flatPicker,
    DropzoneFileUpload,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption
  },
  created(){
    const $this = this
    const token = localStorage.getItem("token")
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    };
    const parameters = {
      "iddistribuidora": 0,
      "codigocategoria": "",
      "grupoventa": ""
    }

    const apiDataPromotion = process.env.VUE_APP_API_URL+"/promocion/data-para-promocion"
    const requestDataPromotion = axios.get(apiDataPromotion,config);
    axios.all([requestDataPromotion]).then(axios.spread((...responses) => {
      const responseDataPromotion = responses[0].data
      $this.tiposVendedor = responseDataPromotion["tiposVendedor"]
      $this.giros = responseDataPromotion["giros"]
      $this.segmentos = responseDataPromotion["segmentos"]
      $this.clusters = responseDataPromotion["clusters"]
      $this.distritos = responseDataPromotion["distritos"]
      $this.diasSemana = responseDataPromotion["diasSemana"]
      $this.grupoVenta = responseDataPromotion["grupoVenta"]
      $this.apiListGroup()
    })).catch(errors => {
      // react on errors.
    })
  },
  computed:{
    async getDistribuidora() {
        try{
            let result = await this.getDistributorList();
            this.distribuidoras = result.data ? result.data.filter((item)=>{return item.estado == "1"}) : [];
        }
        catch(ex){ex}
    }
  },
  methods: {
    ...mapActions({
        getDistributorList: 'distribuidora/getList'
    }),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    submitCreate(values) {
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      let createPromotion  = process.env.VUE_APP_API_URL+"/promocion/crear"
      this.dataSend.obligatorio = Number(this.dataSend.obligatorio)
      document.querySelector(".form_laive").classList.add("validateClient")
      axios.post(createPromotion, this.dataSend,config)
      .then(function (response){
        document.querySelector(".form_laive").classList.remove("validateClient")
        const text = (response.status == 200) ? "Se creó la Promoción" : "Hubo un error";
        const icon = "ni ni-bell-55";
        const content = {
          component: Notification,
          props: {
            icon: icon,
            text: text,
            type: (response.status == 200) ? "success" : "danger",
          },
        };
        const toast = useToast();
        toast(content, {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-right",
        });
        console.log(response);
        setTimeout(() => {
          $this.$router.replace({name: 'Promociones'})
        }, 2000);
      })
      // alert(JSON.stringify(values, null, 2));
    },
    createGrupo(values){
      let $this = this
      this.grupoObjetivo.distribuidoras = this.selectDistribuidoras.join(',')
      this.grupoObjetivo.tiposVendedor = this.selectVendedor.join(',')
      let tempArrGiro = []
      this.selectGiros.forEach(item => {
        let result = this.giros.find( giro => giro.nombre === item );
        tempArrGiro.push(result.codigo);
      });
      this.grupoObjetivo.girosNegocio = tempArrGiro.join(",")

      let tempArrSegmento = []
      this.selectSegmentos.forEach(item => {
        let result = this.segmentos.find( segmento => segmento.nombre === item );
        tempArrSegmento.push(result.codigo);
      });
      this.grupoObjetivo.segmentos = tempArrSegmento.join(",")

      let tempArrClusters = []
      this.selectCluster.forEach(item => {
        let result = this.clusters.find( cluster => cluster.nombre === item );
        tempArrClusters.push(result.codigo);
      });

      let tempArrGrupoVenta = []
      this.selectGrupoVenta.forEach(item => {
        let result = this.grupoVenta.find( grupoventa => grupoventa.nombre === item );
        tempArrGrupoVenta.push(result.codigo);
      });
      this.grupoObjetivo.grupoVenta = tempArrGrupoVenta.join(",")
      this.grupoObjetivo.clusters = tempArrClusters.join(",")
      this.grupoObjetivo.dias = this.selectDias.join(',')
      this.grupoObjetivo.ubigeo = (this.grupoObjetivo.ubigeoTemp.length) ? this.grupoObjetivo.ubigeoTemp.join(',') : ""

      // Create
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };

      document.querySelector(".form_laive").classList.add("validateClient")
      let createGroup  = process.env.VUE_APP_API_URL+"/promocion/crear-grupo"
      axios.post(createGroup, this.grupoObjetivo,config)
      .then(function (response){
        const idGrupo = response.data.idGrupo
        $this.dataSend.idGrupo = idGrupo
        $this.createPromo = true
        console.log({idGrupo})
        const content = {
          component: Notification,
          props: {
            icon: "ni ni-bell-55",
            text: "Se Creo el Grupo objetivo",
            type: "success",
          },
        };
        const toast = useToast();
        toast(content, {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-right",
        });
        document.querySelector(".box_step_grupo").classList.add("d-none")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[1].classList.add("active")
        document.querySelector(".box_step_promotion").classList.remove("d-none")
        $this.apiListGroup();
        $this.apiListProdAsoc(idGrupo)
      })
    },
    uploadFilePromo(){
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      if(File.prototype.isPrototypeOf(this.filePromo)){
        let $this = this
        let uploadImage = process.env.VUE_APP_API_URL+"/promocion/carga-cliente"
        let formData = new FormData();
        formData.append("file", this.filePromo);
        document.querySelector(".form_laive").classList.add("validateClient")
        axios.post(uploadImage, formData, config)
        .then(function(response){
          console.log("file subido")
          const idGrupo = response.data.idGrupo
          $this.dataSend.idGrupo = idGrupo
          $this.createPromo = true
          const content = {
            component: Notification,
            props: {
              icon: "ni ni-bell-55",
              text: "Se Creo el Grupo objetivo",
              type: "success",
            },
          };
          const toast = useToast();
          toast(content, {
            hideProgressBar: true,
            icon: false,
            closeButton: false,
            position: "top-right",
          });
          $this.apiListGroup();
          $this.apiListProdAsoc(idGrupo)
          document.querySelectorAll(".progressbar_vertical .step_grupo")[1].classList.add("active")
          document.querySelector(".box_step_upload").classList.add("d-none")
          document.querySelector(".box_step_promotion").classList.remove("d-none")
        })
      }else{
        const swalError = swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-fill",
          },
          buttonsStyling: false,
        });
        swalError.fire({
          title: `No se ha cargado el documento`,
          confirmButtonText: "Ok",
        });
      }
    },
    clickCreateGroup(event){
      const select = this.$refs.create_group
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      if(select.classList.contains("active")){
        select.classList.remove("active")
        this.createGroup = false
      }else{
        select.classList.add("active")
        this.createGroup = true
      }
      document.querySelector(".initCreatePromo").disabled = false
    },
    clickCreatePromo(event){
      const select = this.$refs.create_promo
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      if(select.classList.contains("active")){
        select.classList.remove("active")
        document.querySelector(".progressbar_vertical .step_grupo").classList.remove("active")
        this.createPromo = false
      }else{
        select.classList.add("active")
        document.querySelector(".progressbar_vertical .step_grupo").classList.add("active")
        this.createPromo = true
      }
      document.querySelector(".initCreatePromo").disabled = false
    },
    clickUploadFile(event){
      const select = this.$refs.upload_file
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      select.classList.toggle("active")
      this.createPromo = false
      this.createPromo = false
      this.uploadFile = true
      document.querySelector(".initCreatePromo").disabled = false
    },
    nextStep(event){
      if(this.createGroup){
        document.querySelector(".promotion_header").classList.add("d-none")
        document.querySelector(".box_step_grupo").classList.remove("d-none")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[0].classList.add("active")
      }else if(this.createPromo){
        document.querySelector(".promotion_header").classList.add("d-none")
        document.querySelector(".box_step_promotion").classList.remove("d-none")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[0].classList.add("active")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[1].classList.add("active")
      }else if(this.uploadFile){
        document.querySelector(".promotion_header").classList.add("d-none")
        document.querySelector(".box_step_upload").classList.remove("d-none")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[0].classList.add("active")
      }
      else{
        const swalError = swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-fill",
          },
          buttonsStyling: false,
        });
        swalError.fire({
          title: `Selccione una opción`,
          confirmButtonText: "Ok",
        });
      }
    },
    backStep(event){
      const select = event.target
      const parent = select.parentElement.parentElement
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      if(parent.classList.contains("box_step_grupo")){
        this.createGroup = false
        parent.classList.add("d-none")
        document.querySelector(".promotion_header").classList.remove("d-none")
      }
      if(parent.classList.contains("box_step_promotion")){
        this.createPromo = false
        parent.classList.add("d-none")
        document.querySelector(".promotion_header").classList.remove("d-none")
      }
      if(parent.classList.contains("box_step_upload")){
        this.createPromo = false
        this.createGroup = false
        parent.classList.add("d-none")
        document.querySelector(".promotion_header").classList.remove("d-none")
      }
      document.querySelector(".initCreatePromo").disabled = true
      document.querySelectorAll(".progressbar_vertical .step_grupo")[0].classList.remove("active")
      document.querySelectorAll(".progressbar_vertical .step_grupo")[1].classList.remove("active")
    },
    changeGroup({id, text}){
      console.log({id, text})
      this.apiListProdAsoc(id)
    },
    selectAllCheckboxes(e){
      const elm = e.target
      let ifChecked = elm.checked
      let parent = elm.parentElement.parentElement
      let objectVal;
      console.log(elm.value)
      switch (elm.value) {
        case "allDis":
          objectVal = this.selectDistribuidoras
          break;
        case "allVendedor":
          objectVal = this.selectVendedor
          break;
        case "allGiros":
          objectVal = this.selectGiros
          break;
        case "allSegment":
          objectVal = this.selectSegmentos
          break;
        case "allCluster":
          objectVal = this.selectCluster
          break;
        case "allGrupoVenta":
          objectVal = this.selectGrupoVenta
          break;
        case "allDias":
          objectVal = this.selectDias
          break;
        default:
          break;
      }
      objectVal.splice(0,objectVal.length);
      if(ifChecked){
        parent.querySelectorAll(".custom-control-input.item").forEach(item => {
          item.checked = ifChecked
          objectVal.push(item.value)
        });
      }
    },
    addFile(file){
      var idxDot = file.name.lastIndexOf(".") + 1;
      var extFile = file.name.substr(idxDot, file.name.length).toLowerCase();
      //console.log({file, idxDot, extFile});
      if(extFile == 'csv' || extFile == 'xlsx' || extFile == 'xls'){
        const template = `<h4>${file.name}</h4>`
        document.querySelector(".block_inner_inmport").innerHTML = template
        this.filePromo = file
      }else{
        const content = {
          component: Notification,
          props: {
            icon: 'ni ni-bell-55',
            text: `El formato ${extFile} no es válido`,
            type: "danger",
          },
        };
        const toast = useToast();
        toast(content, {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-right",
        });
      }
    },
    matchProduct(params, data){
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }
      // Do not display the item if there is no 'text' property
      if (typeof data.text === 'undefined') {
        return null;
      }
      // `params.term` should be the term that is used for searching
      // `data.text` is the text that is displayed for the data object
      if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1 || data.id.indexOf(params.term) > -1) {
        var modifiedData = $.extend({}, data, true);
        //modifiedData.text += ' (matched)';
        // You can return modified objects from here
        // This includes matching the `children` how you want in nested data sets
        return modifiedData;
      }
      // Return `null` if the term should not be displayed
      return null;
    },
    apiListGroup(){
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const apiListGroup = process.env.VUE_APP_API_URL+"/promocion/listar-grupo"
      axios.get(apiListGroup,config)
      .then(function (response){
        const responseDataGroup = response.data
        $this.listGroup = []
        console.log("ajax list group")
        document.querySelector(".form_laive").classList.remove("validateClient")
        responseDataGroup.forEach(item => {
        $this.listGroup.push({
          id: item.idGrupo,
          text: item.nombre,
        })
      });
        return $this.listGroup
      })
    },
    apiListProdAsoc(id){
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const apiListGroup = `${process.env.VUE_APP_API_URL}/promocion/producto/porgrupo/${id}`
      document.querySelector(".form_laive").classList.add("validateClient")
      axios.get(apiListGroup,config)
      .then(function (response){
        const responseData = response.data
        $this.listProductsAsociados = []
        responseData.forEach(item => {
          $this.listProductsAsociados.push({
            id: item.codigoProducto,
            text: item.descripcion,
          })
        });
        $this.listProducts = []
        responseData.forEach(item => {
          $this.listProducts.push({
            id: item.codigoProducto,
            text: item.descripcion,
          })
        });
        document.querySelector(".form_laive").classList.remove("validateClient")
        return $this.listProductsAsociados
      })
    }
  },
  async mounted() {
    await this.getDistribuidora;
  },
  data() {
    return {
      createGroup: false,
      createPromo: false,
      uploadFile: false,
      selectDistribuidoras: [],
      selectVendedor: [],
      selectGiros: [],
      selectSegmentos: [],
      selectCluster: [],
      selectGrupoVenta: [],
      selectDias: [],
      distribuidoras: [],
      tiposVendedor: [],
      giros: [],
      segmentos: [],
      clusters: [],
      distritos: [],
      diasSemana: [],
      grupoVenta: [],
      listProducts: [],
      listProductsAsociados: [],
      listGroup: [],
      productoAsociado: false,
      configDate: {
        altInput: true,
        allowInput: true,
        locale: Spanish, // locale for this instance only
      },
      configDropZone:{
        dictDefaultMessage: `<div class='block_inner_inmport'>
                                <h4>Elige un archivo</h4>
                                <div class='box_icon'>
                                  <i class='far fa-file-alt'></i>
                                </div>
                                <p class="text">o suelta el excel aquí</p>
                              </div>`,
        acceptedFiles: "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      filePromo:[],
      grupoObjetivo:{
        nombre: "",
        distribuidoras: [],
        tiposVendedor: [],
        girosNegocio: [],
        segmentos: [],
        clusters: [],
        dias: [],
        ubigeo: "",
        ubigeoTemp: [],
        minVenta: "",
        maxVenta: "",
        grupoVenta: []
      },
      dataSend:{
        idGrupo: "",
        codigoProducto: "",
        codigoPromocion: "",
        nombre: "",
        codigoProductoAsociado: "",
        descripcion: "",
        obligatorio: "",
        cantidadMinima: "",
        cantidadMaxima: "",
        fechaInicio : "",
        fechaFin : "",
        maximoDisponible: "",
        cantidadPromocion: ""
      }
    };
  },
}
</script>
